export default __webpack_public_path__ + "static/media/step2.a8e504cd.svg";